"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var questions_1 = require("./questions");
exports.QUESTIONS = questions_1.default;
exports.QUESTIONS_BY_CATEGORY_AND_GROUP = questions_1.QUESTIONS_BY_CATEGORY_AND_GROUP;
var utils_1 = require("./utils");
exports.prepareQuestions = utils_1.prepareQuestions;
exports.mapGroupToPageKey = utils_1.mapGroupToPageKey;
//# sourceMappingURL=index.js.map